export enum EWebSocketPerm {
    WEBSOCKET_ACCESS = 'websocket_access'
}
